
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Alert
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PrintIcon from '@mui/icons-material/Print';
import { Order } from "../../types/order";


interface ConfirmationProps {
  order: Order;
  orderResponse?: any;
}

export default function Confirmation({ order, orderResponse }: ConfirmationProps) {
  const handlePrint = () => {
    window.print();
  };

  const confirmationNumber = orderResponse?.id || orderResponse?.documentId || 'N/A';
console.log('Rendering Confirmation with orderResponse:', orderResponse);
  return (
    <Box sx={{ p: 3, textAlign: 'center' }}>
      {/* Success Header */}
      <Box sx={{ mb: 4 }}>
        <CheckCircleOutlineIcon 
          sx={{ 
            fontSize: 80, 
            color: 'success.main', 
            mb: 2 
          }} 
        />
        <Typography variant="h4" component="h2" color="success.main" gutterBottom>
          Registration Confirmed!
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Your conference registration has been successfully submitted.
        </Typography>
      </Box>

      {/* Confirmation Details */}
      <Paper sx={{ p: 3, mb: 3, textAlign: 'left' }}>
        
        <Box sx={{ mt: 2, display: 'grid', gap: 2 }}>
          <Typography variant="body1">
            <strong>Confirmation Number: {orderResponse?.confirmation}</strong>
          </Typography>
          
          {order.conference_group && (
            <Typography variant="body1">
              <strong>Conference:</strong> {order.conference_group.conference.longName}
            </Typography>
          )}
          
          <Typography variant="body1">
            <strong>Contact Name:</strong> {order.contactFirstName} {order.contactLastName}
          </Typography>
          
          <Typography variant="body1">
            <strong>Email:</strong> {order.contactEmail}
          </Typography>
          
          {order.order_rooms && (
            <Typography variant="body1">
              <strong>Rooms Booked:</strong> {order.order_rooms.length} room{order.order_rooms.length !== 1 ? 's' : ''}
            </Typography>
          )}
          
          <Typography variant="body1">
            <strong>Submitted:</strong> {new Date().toLocaleString()}
          </Typography>
        </Box>
      </Paper>

      {/* Next Steps */}
      <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
        <Typography variant="body2" gutterBottom>
          <strong>What happens next?</strong>
        </Typography>
        <Typography variant="body2">
          • A confirmation email will be sent to {order.contactEmail}<br/>
          • A credit card authorization will be sent on April 1st in order to continue to hold room.<br/>
          • Keep your confirmation number for reference
        </Typography>
      </Alert>

      {/* Action Buttons */}
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
        
        <Button
          variant="outlined"
          startIcon={<PrintIcon />}
          onClick={handlePrint}
        >
          Print Confirmation
        </Button>
        
        <Button
          variant="outlined"
          onClick={() => window.location.href = '/'}
        >
          Return to Home
        </Button>
      </Box>

      {/* Important Notes */}
      <Paper sx={{ p: 2, mt: 4, bgcolor: 'grey.50' }}>
        <Typography variant="body2" color="text.secondary">
          <strong>Important:</strong> Please save this confirmation number and check your email for additional details. 
          If you don't receive a confirmation email within 24 hours, please contact support.
        </Typography>
      </Paper>
    </Box>
  );
}